import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';

import { UnwrapAsyncValuePipe } from '@shared/pipes/unwrap-async-value';

import { TableStatusCellProperties } from './table-status-cell.view-model';

@Component({
  selector: 'app-table-status-cell',
  imports: [SvgIconComponent, NgClass, UnwrapAsyncValuePipe],
  templateUrl: './table-status-cell.component.html',
  styleUrl: './table-status-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableStatusCellComponent<T extends string> {
  public properties = input.required<TableStatusCellProperties<T>>();
  public iconSize = input<string>('16');
  public backgroundClasses = input<string>('');
  public status = input.required<T>();
}
